<script>
export default {
  name: 'DuplicateTable',
  props: {
    duplicates: {
      type: Array,
      required: true
    }
  },
  methods: {
    diffInDays(uploadDateTime) {
      const now = new Date();
      const uploadDate = new Date(uploadDateTime);
      const diffTime = Math.abs(now - uploadDate);
      return Math.floor(diffTime / (1000 * 60 * 60 * 24));
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const formattedDate = date.toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
      const formattedTime = date.toLocaleTimeString('de-DE', {
        hour: '2-digit',
        minute: '2-digit'
      });
      return `${formattedDate} ${formattedTime}`;
    }
  }
}
</script>
<template>
  <v-simple-table>
    <thead>
    <tr>
      <th class="text-left">{{$t('table.header.order.number')}}</th>
      <th class="text-left">{{$t('table.header.filename')}}</th>
      <th class="text-left">{{$t('table.header.input.date')}}</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(duplicate, index) in duplicates" :key="index">
      <td>{{ duplicate.orderId }}</td>
      <td>{{ duplicate.fileName }}</td>
      <td>
        <v-tooltip top>
          <template #activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">{{ formatDate(duplicate.uploadDateTime) }}</span>
          </template>
          <span>{{ diffInDays(duplicate.uploadDateTime) }}{{$t('text.days.difference')}}</span>
        </v-tooltip>
      </td>
    </tr>
    </tbody>
  </v-simple-table>
</template>
